import React, { useEffect, useState } from "react";
import {
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  Alert,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";

import "react-phone-input-2/lib/style.css";



const { Text } = Inputs;

function OlvidePassSuperAdmin({ history }) {
  const dispatch = useDispatch();
  const modelOlvide = useSelector((state) => state.olvidePass);
  const [username, setUsername] = useState(null);
  const [link, setLink] = useState(null);

  useEffect(() => {
    const data = modelOlvide?.data?.data;
    const errorMessage = modelOlvide?.error?.response?.data?.mensaje || modelOlvide?.error?.response?.data?.message;
    const error = modelOlvide?.error;

    if (error) {
      alert(errorMessage || "Ocurrió un error al realizar la operación");
      dispatch(controller.duck.actions.clear());
    }
    if (data) {
      if (data.status === 200) {
        setLink(data.data)
        dispatch(controller.duck.actions.clear());
      } else {
        alert(data.mensaje);
        dispatch(controller.duck.actions.clear());
      }
    }
  }, [modelOlvide]);

  function submit() {
    if (!username) {
      return alert("Por favor complete todos los campos");
    }
    let data = {
      email: username,
      returnLink: true
    };
    dispatch(controller.olvidePassThunk(data));
  }
  return (
    <Content
      title="Reestablecer contraseña"
      browserTitle="Reestablecer contraseña"
      show={false}
    >
      <Row>
        <Col md="4" mdOffset="4">
          <Box title="Recuperar contraseña">
            {link && (
              <Col md="12">
                <Alert type="success" title="Exito">
                  <p>{link}</p>
                </Alert>
              </Col>
            )}

            <Text
              labelPosition="above"
              size="sm"
              label="Usuario"
              onChange={(evt) => setUsername(evt.target.value)}
            />
            <Button
              type="primary"
              text="Enviar"
              pullRight={true}
              onClick={() => submit()}
            />
            <Button
              type="default"
              text="Cancelar"
              onClick={() => {
                history.goBack();
              }}
            />
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default OlvidePassSuperAdmin;
